import { get } from "lodash";
import PropTypes from "prop-types";
import { GENDER, ORGANIZATION_FORMS } from "utils/constants";
import { Logo, SelectField, TextField } from "./Fields";
import { CATEGORIES } from "./onboarding";

const GeneralStep = ({ labels, formOptions }) => (
  <>
    <section className="onboarding__section">
      <h3 className="onboarding__section-title">{labels.ORGANIZATION}</h3>
      <div className="onboarding__grid">
        <TextField
          name="organization.name"
          label={labels.NAME}
          placeholder={labels.NAME_PLACEHOLDER}
          required
        />
        <SelectField
          name="organization.type"
          label={labels.CATEGORY}
          options={CATEGORIES.map((value) => ({
            value,
            label: get(labels.CATEGORIES, value, value),
          }))}
          required
        />
        <SelectField
          name="organization.form"
          label={labels.FORM}
          placeholder={labels.FORM_PLACEHOLDER}
          later={labels.LATER}
          options={Object.values(ORGANIZATION_FORMS).map((value) => ({
            value,
            label: get(formOptions, value, value),
          }))}
        />
        <TextField
          name="organization.siretNumber"
          label={labels.SIRET}
          placeholder={labels.SIRET_PLACEHOLDER}
          inputMode="numeric"
          later={labels.LATER}
        />
        <TextField
          name="telecoms.PHONE"
          label={labels.PHONE}
          placeholder={labels.PHONE_PLACEHOLDER}
          type="tel"
        />
        <TextField
          name="telecoms.EMAIL"
          label={labels.EMAIL}
          placeholder={labels.EMAIL_PLACEHOLDER}
          type="email"
        />
        <TextField
          name="telecoms.ADDRESS"
          label={labels.ADDRESS}
          placeholder={labels.ADDRESS_PLACEHOLDER}
        />
        <div className="onboarding__pair">
          <TextField
            name="telecoms.ZIP_CODE"
            label={labels.ZIP_CODE}
            placeholder={labels.ZIP_CODE_PLACEHOLDER}
            inputMode="numeric"
          />
          <TextField
            name="telecoms.CITY"
            label={labels.CITY}
            placeholder={labels.CITY_PLACEHOLDER}
          />
        </div>
      </div>
      <Logo labels={labels} />
    </section>

    <div className="onboarding__divider" />

    <section className="onboarding__section">
      <div>
        <h3 className="onboarding__section-title">{labels.ADMINISTRATOR}</h3>
        <p className="onboarding__hint">{labels.ADMINISTRATOR_HINT}</p>
      </div>
      <div className="onboarding__fields">
        <div className="onboarding__grid onboarding__grid--thirds">
          <SelectField
            name="user.gender"
            label={labels.GENDER}
            placeholder={labels.GENDER_PLACEHOLDER}
            options={[GENDER.FEMALE, GENDER.MALE].map((value) => ({
              value,
              label: get(labels.GENDERS, value, value),
            }))}
            required
          />
          <TextField
            name="user.lastname"
            label={labels.LASTNAME}
            placeholder={labels.LASTNAME_PLACEHOLDER}
            required
          />
          <TextField
            name="user.firstname"
            label={labels.FIRSTNAME}
            placeholder={labels.FIRSTNAME_PLACEHOLDER}
            required
          />
        </div>
        <div className="onboarding__grid">
          <TextField
            name="user.email"
            label={labels.USER_EMAIL}
            placeholder={labels.USER_EMAIL_PLACEHOLDER}
            type="email"
            required
          />
          <TextField
            name="user.phone"
            label={labels.USER_PHONE}
            placeholder={labels.USER_PHONE_PLACEHOLDER}
            type="tel"
            required
          />
        </div>
      </div>
    </section>
  </>
);

GeneralStep.propTypes = {
  labels: PropTypes.object.isRequired,
  formOptions: PropTypes.object,
};

GeneralStep.defaultProps = {
  formOptions: {},
};

export default GeneralStep;
